import { render, staticRenderFns } from "./challenge-list.vue?vue&type=template&id=9889dfb6&scoped=true&"
import script from "./challenge-list.vue?vue&type=script&lang=js&"
export * from "./challenge-list.vue?vue&type=script&lang=js&"
import style0 from "./challenge-list.vue?vue&type=style&index=0&id=9889dfb6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9889dfb6",
  null
  
)

export default component.exports